module.exports = __webpack_public_path__ + "img/home-banner.b98fcd27.png";